import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { serviceCategories, serviceCatalog } from '../lib/catalog';
import { useAuth } from '../context/AuthContext';
export default function ServiceMenu() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  function reserve(service) {
    try { localStorage.setItem('selectedService', service.name); } catch { /* Booking remains available without storage. */ }
    navigate(isAuthenticated ? '/mon-espace?tab=booking' : '/connexion');
  }
  return <div className="korean-menu">{serviceCategories.map(category => <section className="korean-menu-group" key={category.value} aria-labelledby={`category-${category.value}`}>
    <div className="korean-menu-heading"><span className="korean-eyebrow">{category.number} /</span><h3 id={`category-${category.value}`}>{category.label}</h3><p>{category.description}</p></div>
    <div>{serviceCatalog.filter(service => service.category === category.value).map(service => <button className="korean-service" key={service.id} onClick={() => reserve(service)} aria-label={`Réserver ${service.name}, ${service.price} euros`}>
      <span><span className="korean-service-name">{service.name}</span><span className="korean-service-desc">{service.description}</span></span>
      <span className="korean-service-price">{service.price}<small> €</small></span><ArrowUpRight size={20} aria-hidden="true" />
    </button>)}</div>
  </section>)}</div>;
}
